import React, { useState, useEffect } from 'react';
import {
  Box, Container, Typography, Paper, Alert, CircularProgress, Button
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

const primaryColor = '#B200BB';

const PaymentInstructions = () => {
  const navigate = useNavigate();

  const [checkingAuth, setCheckingAuth] = useState(true);
  const [userStatus, setUserStatus] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate('/signin');
      } else {
        const docSnap = await getDoc(doc(db, 'users', user.uid));
        if (docSnap.exists()) {
          setUserStatus(docSnap.data().status);
        }
      }
      setCheckingAuth(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  if (checkingAuth) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}><CircularProgress /></Box>;

  const isRejected = userStatus === 'rejected';

  return (
    <Box sx={{ py: 12, bgcolor: '#f9f9f9', minHeight: '100vh', textAlign: 'center' }}>
      <Container maxWidth="sm">
        <Paper elevation={0} sx={{ p: 5, borderRadius: '24px', border: '1px solid #e0e0e0' }}>
          <Typography variant="h5" fontWeight={800} gutterBottom>
            {isRejected ? 'Application Not Approved' : 'Account Under Review'}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {isRejected
              ? 'Unfortunately your application was not approved. Please contact support if you believe this is a mistake.'
              : 'Thanks for verifying your email. Your application is currently being reviewed by our team. This process usually takes less than 72 hours.'}
          </Typography>
          {!isRejected && (
            <Alert severity="info" sx={{ borderRadius: '12px', textAlign: 'left' }}>
              Once an administrator approves your application, you will gain full access to Bouldou.
            </Alert>
          )}
          <Button
            variant="text"
            onClick={() => navigate('/')}
            sx={{ mt: 3, color: primaryColor, fontWeight: 700 }}
          >
            Back to Homepage
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default PaymentInstructions;
